import styled from "styled-components";
import { FcCalendar } from "react-icons/fc";
import { FaPlus } from "react-icons/fa";

const CalendarPlusIcon = () => {
  return (
    <StyledCalendarPlusIcon>
      <FcCalendar />
      <FaPlus className="plus-icon" />
    </StyledCalendarPlusIcon>
  );
};

const StyledCalendarPlusIcon = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  background: var(--fc-tournament-satellite-muted);
  padding: 0.2rem;
  border-radius: 5px;
  line-height: 1;
  cursor: pointer;

  svg {
    font-size: 1.1rem;
  }

  .plus-icon {
    font-size: 0.65rem;
    color: var(--fc-tournament-satellite);
  }
`;

export default CalendarPlusIcon;
